import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';

import { SurveyBuilder } from './survey-builder';
import { SurveyTracker } from './survey-tracker';
import { SurveyListItem } from './survey-list-item';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 12px 0 0;
  overflow-y: scroll;
  height: 100%;
`;

const mapState = createSelector(
  ({ surveys }) => surveys,
  (surveys) => ({ surveys })
);

export const SurveySidebar = () => {
  const [open, setOpen] = useState(false);
  const [trackerOpen, setTrackerOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const dispatch = useDispatch();
  const { surveys } = useSelector(mapState);

  useEffect(() => {
    if (loaded) return;

    dispatch({
      type: 'FETCH_SURVEYS',
    });
    setLoaded(true);
  }, [dispatch, loaded, setLoaded]);

  const createNewSurvey = useCallback(() => {
    setOpen(true);
    dispatch({ type: 'CREATE_SURVEY' });
  }, [dispatch, setOpen]);

  const editSurvey = useCallback(
    (e, survey) => {
      e.preventDefault();
      e.stopPropagation();
      dispatch({
        type: 'EDIT_SURVEY',
        payload: { survey },
      });
      setOpen(true);
    },
    [dispatch, setOpen]
  );

  const showGrid = useCallback(
    (e, survey) => {
      dispatch({
        type: 'EDIT_SURVEY',
        payload: { survey },
      });
      setTrackerOpen(true);
    },
    [dispatch, setTrackerOpen]
  );

  const handleClose = useCallback(() => {
    dispatch({
      type: 'STOP_EDITING_SURVEY',
    });
    setOpen(false);
  }, [dispatch, setOpen]);

  const handleTrackerClose = useCallback(() => {
    setTrackerOpen(false);
  }, [setTrackerOpen]);

  return (
    <Container>
      <Typography>Surveys</Typography>
      <br />
      <Button variant="contained" color="primary" onClick={createNewSurvey}>
        Create a Survey
      </Button>
      <br />
      <Grid container>
        {Object.values(surveys).map((survey) => (
          <SurveyListItem
            key={survey.id}
            survey={survey}
            showGrid={showGrid}
            editSurvey={editSurvey}
          />
        ))}
      </Grid>
      <SurveyBuilder open={open} handleClose={handleClose} />
      <SurveyTracker open={trackerOpen} handleClose={handleTrackerClose} />
    </Container>
  );
};
